import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const { isLogin, menu } = useSelector((state) => state?.auth);
  const location = useLocation();
  
  // Extract the main path from the location
  const currentPath = location.pathname.split('/')[1];
  
  // Define special routes that bypass menu checking
  const specialRoutes = ["corporates", "profile"];
  
  // Check if user has access to this route
  const hasAccess = () => {
    // Allow access to special routes without menu checking
    if (specialRoutes.includes(currentPath)) return true;
    
    if (!menu || !Array.isArray(menu)) return false;
    
    // Find menu item for current path
    const menuItem = menu.find(item => 
      item.router === currentPath || 
      (currentPath === '' && item.router === 'dashboard')
    );
    
    // Check if user has read access
    return menuItem?.selectedApplicationAccessControlList?.some(
      access => access.accessControlId === 2 // Read access
    );
  };
  
  // If user is not logged in, redirect to login
  if (!isLogin) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If user is logged in but doesn't have access to this route
  if (currentPath && !hasAccess()) {
    // Redirect to first accessible route or dashboard
    const firstAccessibleRoute = menu?.find(item => 
      item.selectedApplicationAccessControlList?.some(
        access => access.accessControlId === 2
      )
    );
    
    return <Navigate to={firstAccessibleRoute?.router || '/profile'} replace />;
  }
  
  // User is logged in and has access to this route
  return element;
};

export default ProtectedRoute;
